import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'servicedesk.automation.global-error.header',
		defaultMessage: 'Oops, something went wrong!',
		description: '',
	},
	unauthorized: {
		id: 'servicedesk.automation.global-error.unauthorized',
		defaultMessage: 'You are not logged in. Please log in again to view this page.',
		description: '',
	},
	forbidden: {
		id: 'servicedesk.automation.global-error.forbidden',

		defaultMessage:
			'You are not able to view this page. It can only be accessed by a Project Administrator.',

		description: '',
	},
	internalServerError: {
		id: 'servicedesk.automation.global-error.internal-server-error',

		defaultMessage:
			'There was a problem while communicating with the server. Please try again later.',

		description: '',
	},
	logIn: {
		id: 'servicedesk.automation.global-error.log-in',
		defaultMessage: 'Log in',
		description: '',
	},
	goBack: {
		id: 'servicedesk.automation.global-error.go-back',
		defaultMessage: 'Go back',
		description: '',
	},
});
